import { render, staticRenderFns } from "./FeaturedGOC.vue?vue&type=template&id=26f913ff&scoped=true&"
import script from "./FeaturedGOC.vue?vue&type=script&lang=js&"
export * from "./FeaturedGOC.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedGOC.vue?vue&type=style&index=0&id=26f913ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f913ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f913ff')) {
      api.createRecord('26f913ff', component.options)
    } else {
      api.reload('26f913ff', component.options)
    }
    module.hot.accept("./FeaturedGOC.vue?vue&type=template&id=26f913ff&scoped=true&", function () {
      api.rerender('26f913ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/GOCComponents/FeaturedGOC.vue"
export default component.exports